import { styled } from '@linaria/react';

import { MqTablet } from '~shared/ui/theme/media';

export const GridPaginationWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: 1170px;
	justify-content: center;
	margin: 32px auto;
`;

export const Container = styled.div`
	display: flex;
	margin: 0 auto;
	gap: var(--gap-x2);

	${MqTablet} {
		gap: var(--gap-x3);
	}
`;

export const MobileContainer = styled(Container)`
	display: flex;

	${MqTablet} {
		display: none;
	}
`;

export const DesktopContainer = styled(Container)`
	display: none;

	${MqTablet} {
		display: flex;
	}
`;

export const Cell = styled.div<{
	border?: boolean;
	bg?: boolean;
	transparent?: boolean;
}>`
	display: flex;
	width: 44px;
	height: 44px;
	align-items: center;
	justify-content: center;
	border: 1px solid
		${({ border }) => (border ? 'var(--color-white-solid)' : 'transparent')};
	border-radius: var(--radius-xxs);
	background-color: ${({ bg }) =>
		bg === false ? 'transparent' : 'var(--color-white-xs)'};
	opacity: ${({ transparent }) => (transparent ? 0.4 : 1)};

	${MqTablet} {
		background-color: ${({ bg }) =>
			bg ? 'var(--color-white-xs)' : 'transparent'};
	}
`;
